
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import _Link from 'next/link'
import { Heading as _Heading } from '@/components/Heading'
const meta = {};
const slug = '_scaling';
const tableOfContents = [{
  "title": "------",
  "slug": "",
  "children": []
}];

const layoutProps = {
  meta,
slug,
tableOfContents
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <_Heading level={2} id={""} nextElement={{
      "type": "paragraph"
    }}>------</_Heading>
    <p>{`Established and looking to expand & Scale? `}</p>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">{`Fleet Management System to manage your own deliveries thus reducing cost and providing end-to-end delightful experience for your customers`}</li>
      <li parentName="ul">{`Mobile Apps for your customers, so they can be in touch with you everyday `}</li>
      <li parentName="ul">{`Additional Integrations on backend level (Via API and Webhooks) to support with your internal systems`}</li>
    </ul>



    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
MDXContent.layoutProps = layoutProps
